import React from 'react';
import loadable from '@loadable/component';

/**
 * Placeholder shown while FooterLazy chunk loads.
 * Reserves vertical space to reduce CLS before the real footer hydrates.
 */
const FooterSkeleton = () => (
    <div
        aria-hidden="true"
        data-automation-id="jcp-footer-skeleton"
        style={{ minHeight: 400, width: '100%' }}
    />
);

export default loadable(() => import(/* webpackChunkName: "FooterLazy" */ './YodaFooter'), {
    fallback: <FooterSkeleton />,
});
